import React from 'react'
import UpgradeToGetStarted from '../../components/UpgradeToGetStarted/UpgradeToGetStarted'
import { Box, Button, Typography } from '@mui/material'
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import { useNavigate } from 'react-router-dom';
const TimesheetApprovalsReport = () => {
  const navigate = useNavigate();
  return (
    <div>
      <Box>
        <Button
          onClick={() => navigate('/reports')}
          style={{
            color: '#1A1F36',
            fontSize: '24px',
            fontWeight: '600',
            display: 'flex',
            alignItems: 'center',
            gap: 2,
            marginBottom: '24px',
            textTransform: "capitalize",
            padding: '0',
            marginLeft: '-10px'
          }}
        >
          <KeyboardArrowLeftIcon
            sx={{ color: '#1760EC', width: '30px', height: '30px' }}
          />
          Reports
        </Button>
      </Box>

      <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
        <Typography variant="h6" fontWeight="600" fontSize={17} color='#111827'>
          Timesheet approvals report
        </Typography>
      </Box>
      <UpgradeToGetStarted
        imageSrc="/assets/images/timesheet/timesheetapprovals.png"
        imageAlt="Timesheet Approvals"
        heading="..."
        description="..."
        lockIconSrc="./assets/images/app-activity/insights/lock-icon.svg"
        promoText="Schedule a call with our sales team to discover more about Timesheet approvals."
        buttonText="Upgrade to get started"
        showTextContent={false}
      />
    </div>
  )
}

export default TimesheetApprovalsReport
